export const getPluralKey = (count: number) => {
	const lastDigit = count % 10;
	const lastTwoDigits = count % 100;

	if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
		return 'many'; // 11, 12, 13, 14
	}

	if (lastDigit === 1) {
		return 'one'; // 1, 21, 31, ...
	}

	if (lastDigit >= 2 && lastDigit <= 4) {
		return 'few'; // 2-4, 22-24, 32-34, ...
	}

	return 'many'; // 0, 5-9, 10, 20, 25-30, ...
};
